import { createFilter } from '@cmctechnology/phoenix-stockbroking-web-design';

export const filterByStartWith = createFilter({
  matchFrom: `start`
});
